'use strict'

var header = document.getElementById('site-header')
var submenu = document.getElementById('infographics-navigation')

function stickyHeader () {
  if (window.pageYOffset >= submenu.offsetTop) {
    header.classList.add('sticky')
  } else {
    header.classList.remove('sticky')
  }
}

function toggleHeader () {
  if (window.pageYOffset >= intro.offsetTop) {
    header.classList.add('deployed')
  } else {
    header.classList.remove('deployed')
  }
}

if (submenu) {
  window.addEventListener('scroll', stickyHeader)
}

if (document.body.classList.contains('home')) {
  var intro = document.getElementById('intro')
  window.addEventListener('scroll', toggleHeader)
}

var hamburger = document.querySelector('.hamburger')
var menu = document.querySelector('.main-navigation')
hamburger.addEventListener('click', () => {
  hamburger.classList.toggle('is-active')
  menu.classList.toggle('is-active')
  document.body.classList.toggle('fixed')
})
